import { Controller } from '@hotwired/stimulus';

// 配下の reveal をまとめて開閉する親コントローラー。
export default class extends Controller {
  static targets = ['button'];

  static outlets = ['reveal'];

  static values = { openLabel: String, closeLabel: String };

  revealOutletConnected() {
    this.refreshButton();
  }

  toggleAll() {
    if (this.anyClosed()) {
      this.revealOutlets.forEach((outlet) => outlet.open());
    } else {
      this.revealOutlets.forEach((outlet) => outlet.close());
    }
    this.refreshButton();
  }

  refreshButton() {
    this.buttonTarget.textContent = this.anyClosed() ? this.openLabelValue : this.closeLabelValue;
  }

  anyClosed() {
    return this.revealOutlets.some((outlet) => outlet.contentTargets.some((element) => element.hidden));
  }
}
